import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_generation, use_slice_ui } from '@/hooks/store/use_slices';
import { LOCAL__ui_set_string } from '@/state/ui/_base/LOCAL__ui_set_string';

export function WATCHER__generation_tool_output_type() {
  const dispatch = use_dispatch();

  const { generation_current } = use_slice_generation(['generation_current']);
  const { g_tools__output_type } = use_slice_ui(['g_tools__output_type']);

  const { graph } = generation_current.tool;

  use_effect(() => {
    if (graph.is_stub()) return;
    if (graph.meta.output_type == g_tools__output_type) return;

    dispatch(LOCAL__ui_set_string({ key: 'g_tools__output_type', value: graph.meta.output_type, valid_values: [] }));
  }, [graph]);

  return null;
}
